import {
  Cascader,
  DatePicker,
  Button,
  Select,
  Table,
  Modal,
  Input,
  message,
  ConfigProvider,
} from "antd";
import dayjs from "dayjs";
import { useCallback, useRef, useState, useEffect } from "react";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import {
  getSmartBeanAuditStatusList,
  auditApllyStatus,
  exportSmartBeansAuditExelFile,
} from "../../../api/smartBeans";
import "./index.styl";
import locale from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

export default function SmartBeansAudit() {
  const searchContent = useRef("");
  const learnStatus = useRef("");
  const smartBeans = useRef(0);
  const [searchTime, setSearchTime] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [statusSearch, setStatusSearch] = useState("-1");
  const [audioDataList, setAudioDataList] = useState([]);

  const pageNum = useRef(1);
  const [pageSize, setPageSize] = useState(10);
  const curPageSize = useRef(10);

  const [selectedKeys, setSelectdRowKeys] = useState([]);

  // 必经帐号
  const userAccount = useRef("");

  // 主模块
  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState("");

  // 子模块
  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState("");

  // 角色
  const [roleData, setRoleData] = useState([]);
  const [defaultRoleKey, setDefaultRoleKey] = useState("");

  // 获取主模块数据
  useEffect(() => {
    async function fetchMainModuleList() {
      const mainModuleList = [{ id: -1, name: "全部" }];
      const res = await getMainModuleList();
      if (res?.code == 0 && res?.data?.length > 0) {
        mainModuleList.push(...res.data);
      }
      setMainModuleData(mainModuleList);
      setDefaultMainModuleKey(mainModuleList[0].id);
    }

    fetchMainModuleList();
  }, []);

  // 当前时间
  const [pickerValue, setPickerValue] = useState([]);

  // 选择主模块item
  const onMainModuleItemSelected = useCallback(async (id, option) => {
    const newChildModuleData = [{ id: "-1", name: "全部" }];
    const newRoleData = [{ id: "-1", name: "全部" }];

    if (id > "") {
      const res = await getChildModuleList({ main_depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        newChildModuleData.push(...res.data);
      }
    }

    setDefaultMainModuleKey(id);
    setChildModuleData(newChildModuleData);
    setDefaultChildModuleKey(newChildModuleData[0].id);
    setRoleData(newRoleData);
    setDefaultRoleKey(newRoleData[0].id);
  }, []);

  // 选择子模块
  const onChildModuleItemSelected = useCallback(async (id, option) => {
    const newRoleData = [{ id: "-1", name: "全部" }];

    try {
      if (id > "") {
        const res = await getRoleList({ depart_id: id });
        console.log("res+_+_", res);
        if (res.code == 0 && res.data?.length > 0) {
          newRoleData.push(...res.data);
        }
      }
    } catch (error) {
      console.log(error);
    }

    setDefaultChildModuleKey(id);
    setRoleData(newRoleData);
    setDefaultRoleKey(newRoleData[0].id);
  }, []);

  // 选择角色
  const onRoleItemSelected = useCallback((id, option) => {
    setDefaultRoleKey(id);
  }, []);

  // 必经帐号
  const onUserAccountChanged = useCallback((e) => {
    userAccount.current = e.target.value;
  }, []);

  // 查询时间
  const dateStr = useRef("");
  const onSearchDateStrChanged = useCallback((data, dataStr) => {
    dateStr.current = dataStr;
  }, []);

  // 智慧豆增减
  const smartBeansStatus = useRef("");
  const onSmartBeansStatusChanged = useCallback((id, option) => {
    smartBeansStatus.current = id;
  }, []);

  // 申请时间
  const applyTimeArr = useRef([]);
  const onApplyTimeChanged = useCallback((timeArr) => {
    applyTimeArr.current = timeArr;
  }, []);

  // 获取审核列表
  const searchAuditList = useCallback(async () => {
    const status = statusSearch != -1 ? statusSearch : null;
    const startTime =
      applyTimeArr.current.length < 2 || !(applyTimeArr.current[0] > "")
        ? null
        : `${applyTimeArr.current[0]}` + "%20" + `00:00:00`;
    const endTime =
      applyTimeArr.current.length < 2 || !applyTimeArr.current[1] > ""
        ? null
        : `${applyTimeArr.current[1]}` + "%20" + `23:59:59`;
    const roleKey =
      defaultRoleKey > "" && defaultRoleKey != "-1" ? defaultRoleKey : null;
    const jobTime =
      dateStr.current > "" ? dateStr.current + "-01" + "%2000:00:00" : null;
    const mainModuleid =
      defaultMainModuleKey > "" && defaultMainModuleKey != "-1"
        ? defaultMainModuleKey
        : null;
    const childModuleId =
      defaultChildModuleKey > "" && defaultChildModuleKey != "-1"
        ? defaultChildModuleKey
        : null;
    const smartBeanStatus =
      smartBeansStatus.current > "" && smartBeansStatus.current != "-1"
        ? smartBeansStatus.current
        : null;

    const params = {
      page_no: pageNum.current,
      page_size: curPageSize.current,
      audit_status: status,
      begin_time: startTime,
      end_time: endTime,
      job_id: roleKey,
      job_time: jobTime,
      main_depart_id: mainModuleid,
      second_depart_id: childModuleId,
      type: smartBeanStatus == 0 ? null : smartBeanStatus,
      user_no: userAccount.current > "" ? userAccount.current : null,
    };
    const res = await getSmartBeanAuditStatusList(params);
    if (res.code == 0 && res.data && res.data.list?.length > 0) {
      res.data.list.forEach((element) => {
        element.key = element.id;
        if (!element.main_depart_name) {
          element.main_depart_name = "-";
        }
        if (!element.second_depart_name) {
          element.second_depart_name = "-";
        }
        if (!element.job_name) {
          element.job_name = "-";
        }
      });
      setAudioDataList(res.data.list);
      setAuditListTotalNum(res.data.count || 0);
    } else {
      setAudioDataList([]);
      setAuditListTotalNum(0);
    }
  }, [
    statusSearch,
    defaultMainModuleKey,
    defaultChildModuleKey,
    defaultRoleKey,
    pageSize,
  ]);

  const onDownLoadBtnClicked = useCallback(() => {
    const status = statusSearch != -1 ? statusSearch : null;
    const startTime =
      applyTimeArr.current.length < 2 || !(applyTimeArr.current[0] > "")
        ? null
        : `${applyTimeArr.current[0]}%2000:00:00`;
    const endTime =
      applyTimeArr.current.length < 2 || !applyTimeArr.current[1] > ""
        ? null
        : `${applyTimeArr.current[1]}%2023:59:59`;
    const roleKey =
      defaultRoleKey > "" && defaultRoleKey != "-1" ? defaultRoleKey : null;
    const jobTime =
      dateStr.current > "" ? dateStr.current + "-01%2000:00:00" : null;
    const mainModuleid =
      defaultMainModuleKey > "" && defaultMainModuleKey != "-1"
        ? defaultMainModuleKey
        : null;
    const childModuleId =
      defaultChildModuleKey > "" && defaultChildModuleKey != "-1"
        ? defaultChildModuleKey
        : null;
    const smartBeanStatus =
      smartBeansStatus.current > "" && smartBeansStatus.current != "-1"
        ? smartBeansStatus.current
        : null;

    const params = {
      audit_status: status,
      begin_time: startTime,
      end_time: endTime,
      job_id: roleKey,
      job_time: jobTime,
      main_depart_id: mainModuleid,
      second_depart_id: childModuleId,
      type: smartBeanStatus == 0 ? null : smartBeanStatus,
      user_no: userAccount.current > "" ? userAccount.current : null,
    };

    exportSmartBeansAuditExelFile(params);
  }, [
    statusSearch,
    defaultMainModuleKey,
    defaultChildModuleKey,
    defaultRoleKey,
  ]);

  // 点击查询
  const onSearchBtnClicked = useCallback(async () => {
    pageNum.current = 1;
    setSelectdRowKeys([]);
    setAuditListCurPage(1);
    searchAuditList();
  }, [searchAuditList]);

  // 初始化列表数据
  useEffect(() => {
    onSearchBtnClicked();
  }, [onSearchBtnClicked]);

  const [auditListTotalNum, setAuditListTotalNum] = useState(0);
  const [auditListCurPage, setAuditListCurPage] = useState(1);

  // 主列表分页属性
  const paginationProps = {
    // showSizeChanger: true,
    // showQuickJumper: true,
    showTotal: () => `共${auditListTotalNum}条`,
    pageSize: pageSize,
    current: auditListCurPage,
    total: auditListTotalNum,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current, pageSize) => onChangeAuditListpage(current, pageSize),
  };

  const onChangeAuditListpage = useCallback(
    (current, size) => {
      if (curPageSize.current != size) {
        setPageSize(size);
        curPageSize.current = size;
        onSearchBtnClicked();
        return;
      }
      setSelectdRowKeys([]);
      pageNum.current = current;
      searchAuditList();
      setAuditListCurPage(current);
    },
    [searchAuditList, curPageSize, onSearchBtnClicked]
  );

  // 审核
  const onAuditBtnClicked = useCallback(
    async (isApprove, keys = []) => {
      if (selectedKeys.length < 1 && keys.length < 1) {
        message.warning("请选择要审核的数据");
        return;
      }

      const auditStatus = isApprove ? 1 : 2;
      const ids = keys.length > 0 ? keys.join(",") : selectedKeys.join(",");
      console.log("ids+_+__:", ids);
      const params = {
        audit_status: auditStatus,
        ids,
      };

      const res = await auditApllyStatus(params);
      if (res.code == 0) {
        message.success("审核成功");
        setSelectdRowKeys([]);
        onSearchBtnClicked();
      } else {
        message.error("审核失败");
      }
      setShowModal(false);
    },
    [selectedKeys, onSearchBtnClicked]
  );

  const options = [
    {
      value: "1",
      label: "村名",
      children: [
        {
          value: "1",
          label: "中医村02期",
        },
      ],
    },
  ];
  const dataSource = [
    {
      id: "1",
      user_no: "丁大虾",
      ctime: "2024 0710",
      smartBeanStatus: "智慧豆增减",
      main_depart_name: "智慧栈",
      second_depart_name: "-",
      job_name: "培训组组长",
      type: "0",
      bean_amount: "20",
    },
  ];

  const columns = [
    {
      title: "学号",
      dataIndex: "user_no",
      key: "user_no",
    },
    {
      title: "昵称",
      dataIndex: "stu_nick_name",
      key: "stu_nick_name",
    },
    {
      title: "申请时间",
      dataIndex: "ctime",
      key: "ctime",
    },
    {
      title: "智慧豆增减",
      dataIndex: "type",
      key: "type",
      render: (text) => <div>{text == "1" ? "增加" : "扣除"}</div>,
    },
    {
      title: "板块",
      dataIndex: "main_depart_name",
      key: "main_depart_name",
    },
    {
      title: "子板块",
      dataIndex: "second_depart_name",
      key: "second_depart_name",
    },
    {
      title: "人物角色内容",
      dataIndex: "job_name",
      key: "job_name",
    },
    {
      title: "智慧豆",
      dataIndex: "bean_amount",
      key: "bean_amount",
    },
    {
      title: "创建者昵称",
      dataIndex: "creator_nick_name",
      key: "creator_nick_name",
    },
    {
      title: "创建者电话",
      dataIndex: "phone_no",
      key: "phone_no",
    },
    {
      title: "状态",
      dataIndex: "audit_status",
      key: "audit_status",
      render: (text) => (
        <div>
          {text == "0" ? "待审核" : text == 1 ? "审核通过" : "审核未通过"}
        </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button onClick={() => onShowDetailBtnClicked(record)} type="link">
            查看详情
          </Button>
          {/* <Button onClick={onSmartBeansClicked} type="link">
            修改
          </Button> */}
        </div>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
      const selectedKeys = selectedRows.map((item) => item.id);
      // console.log("selectedRowKeys:__", selectedKeys);
      setSelectdRowKeys(selectedKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const smartBeansDetailDataSource = [
    {
      key: "1",
      timestamp: "2024.5.17 21:34:21",
      module: "天空训练营",
      childModule: "---",
      role: "观察员",
      smartBeans: "20",
    },
  ];

  const smartBeansDetail = [
    {
      title: "录入时间",
      dataIndex: "timestamp",
      key: "timestamp",
    },
    {
      title: "板块",
      dataIndex: "module",
      key: "module",
    },
    {
      title: "子板块",
      dataIndex: "childModule",
      key: "childModule",
    },
    {
      title: "人物角色/内容",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "智慧豆",
      dataIndex: "smartBeans",
      key: "smartBeans",
    },
  ];

  const onSearchContentChanged = useCallback((val) => {
    if (!val || !Array.isArray(val) || val.length < 2) return;

    const content = val.join(",");
    searchContent.current = content;
  }, []);

  const onSearchTimeChanged = useCallback((val) => {
    console.log(val);
  }, []);

  const onLearnStatusChanged = useCallback((val) => {}, []);

  const onSmartBeansChanged = useCallback((val) => {}, []);

  const auditDetail = useRef("");
  const onShowDetailBtnClicked = useCallback((record) => {
    auditDetail.current = record;
    setShowModal(true);
  }, []);

  const onSmartBeansActionChanged = useCallback((e) => {}, []);
  const onStatusSearchChanged = useCallback((val) => {
    setStatusSearch(val);
  }, []);

  const onRecentDaysClicked = useCallback((days) => {
    const curDateStr = dayjs().format(dateFormat);
    const daysAgo = dayjs().subtract(days, "day");
    const daysAgoStr = dayjs(daysAgo.$d).format(dateFormat);
    onApplyTimeChanged([daysAgoStr, curDateStr]);

    setPickerValue([
      dayjs(daysAgoStr, dateFormat),
      dayjs(curDateStr, dateFormat),
    ]);
  }, []);

  return (
    <div className="container">
      <div className="searchContainer">
        <div className="searchInputContainer">
          <div className="searchItem">
            选择年月：
            <ConfigProvider locale={locale}>
              <DatePicker
                style={{ width: 180 }}
                onChange={onSearchDateStrChanged}
                picker="month"
              />
            </ConfigProvider>
          </div>
          <div className="searchItem">
            智慧豆增减：
            <Select
              defaultValue="0"
              style={{ width: 180 }}
              onChange={onSmartBeansStatusChanged}
              options={[
                { value: "0", label: "全部" },
                { value: "1", label: "录入" },
                { value: "2", label: "扣除" },
              ]}
            />
          </div>
          {/* <div className="searchItem">
            分类：
            <Select
              defaultValue="1"
              style={{ width: 180 }}
              onChange={onSmartBeansActionChanged}
              options={[
                { value: "0", label: "全部" },
                { value: "1", label: "录入" },
                { value: "2", label: "扣除" },
              ]}
            />
          </div> */}
          {/* <div className="searchItem">
            选择村名：
            <Select
              defaultValue="1"
              style={{ width: 180 }}
              onChange={onSmartBeansActionChanged}
              options={[
                { value: "1", label: "全部" },
                { value: "2", label: "金刚村" },
                { value: "3", label: "中医村" },
              ]}
            />
          </div> */}
          <div className="searchItem">
            选择模块：
            <Select
              value={defaultMainModuleKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onMainModuleItemSelected}
              options={mainModuleData}
            />
          </div>
          <div className="searchItem">
            子模块：
            <Select
              value={defaultChildModuleKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onChildModuleItemSelected}
              options={childModuleData}
            />
          </div>
          <div className="searchItem">
            角色：
            <Select
              value={defaultRoleKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onRoleItemSelected}
              options={roleData}
            />
          </div>
          <div className="searchItem">
            昵称/学号：
            <Input
              placeholder="输入昵称/学号"
              style={{ height: 32, width: 180, paddingLeft: 10 }}
              onChange={onUserAccountChanged}
            />
          </div>
          <div className="searchItem">
            申请时间：
            <ConfigProvider locale={locale}>
              <RangePicker
                format={dateFormat}
                onChange={(value, dateArr) => {
                  onApplyTimeChanged(dateArr);
                  setPickerValue(value);
                }}
                value={pickerValue}
              />
            </ConfigProvider>
          </div>
          <Button
            onClick={() => onRecentDaysClicked(7)}
            className="searchItem"
            type="primary"
          >
            近7天
          </Button>
          <Button
            onClick={() => onRecentDaysClicked(30)}
            className="searchItem"
            type="primary"
          >
            近30天
          </Button>
        </div>

        <div className="btnContainer">
          <Button
            style={{ marginTop: 20 }}
            className="searchItem"
            type="primary"
            onClick={onSearchBtnClicked}
          >
            查询
          </Button>
          <Button
            style={{ marginTop: 20, marginLeft: 20 }}
            className="searchItem"
            type="primary"
            onClick={() => onAuditBtnClicked(true)}
          >
            通过
          </Button>
          <Button
            style={{ marginTop: 20, marginLeft: 20 }}
            className="searchItem"
            type="primary"
            onClick={() => onAuditBtnClicked(false)}
          >
            不通过
          </Button>
          <Button
            onClick={onDownLoadBtnClicked}
            style={{ marginTop: 20 }}
            className="searchItem"
            type="link"
          >
            下载列表Excel
          </Button>
        </div>
      </div>

      <div className="contentContainer">
        <div className="statusBtnContainer">
          <div
            onClick={() => onStatusSearchChanged(-1)}
            style={{
              backgroundColor:
                statusSearch == "-1" ? "white" : "rgba(0, 0, 0, 0.1)",
            }}
            className="statusBtn"
          >
            全部
          </div>
          <div
            onClick={() => onStatusSearchChanged(0)}
            style={{
              backgroundColor:
                statusSearch == "0" ? "white" : "rgba(0, 0, 0, 0.1)",
            }}
            className="statusBtn"
          >
            待审核
          </div>
          <div
            onClick={() => onStatusSearchChanged(1)}
            style={{
              backgroundColor:
                statusSearch == "1" ? "white" : "rgba(0, 0, 0, 0.1)",
            }}
            className="statusBtn"
          >
            已通过
          </div>
          <div
            onClick={() => onStatusSearchChanged(2)}
            style={{
              backgroundColor:
                statusSearch == "2" ? "white" : "rgba(0, 0, 0, 0.1)",
            }}
            className="statusBtn"
          >
            未通过
          </div>
        </div>
        <Table
          pagination={paginationProps}
          // selectedRowKeys={selectedKeys}
          rowSelection={rowSelection}
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log(event);
              },
            };
          }}
          dataSource={audioDataList}
          columns={columns}
        />
      </div>

      <Modal
        title="申请信息"
        open={showModal}
        width={500}
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            // alignItems: "center",
            // justifyContent: "center",
            flexDirection: "column",
            paddingTop: 30,
            paddingRight: 50,
            paddingLeft: 50,
          }}
        >
          <div style={{ fontWeight: 500 }}>
            {auditDetail.current.stu_nick_name > ""
              ? auditDetail.current.user_no +
                `(${auditDetail.current.stu_nick_name ?? "-"})`
              : auditDetail.current.user_no}
          </div>
          {auditDetail.current.type == 1 ? (
            <div style={{ marginTop: 10 }}>
              在
              <span style={{ fontWeight: 500 }}>
                {auditDetail.current.main_depart_name > "" &&
                auditDetail.current.main_depart_name != "-"
                  ? ` ${auditDetail.current.main_depart_name}`
                  : ""}
              </span>
              <span style={{ fontWeight: 500 }}>
                {auditDetail.current.second_depart_name > "" &&
                auditDetail.current.second_depart_name != "-"
                  ? `-${auditDetail.current.second_depart_name}，`
                  : "，"}
              </span>
              担任
              <span style={{ fontWeight: 500 }}>
                {auditDetail.current.job_name > "" &&
                auditDetail.current.job_name != "-"
                  ? `-${auditDetail.current.job_name}，`
                  : ""}
              </span>
              服务次数
              <span
                style={{ fontWeight: 500, color: "red" }}
              >{`${auditDetail.current.job_num}次，`}</span>
            </div>
          ) : null}
          <div>
            在此申请
            <span>{auditDetail.current.type == 1 ? "奖励" : "扣除"}</span>
            <span style={{ fontWeight: 500, color: "red" }}>
              {" " + auditDetail.current.bean_amount + " "}
            </span>
            智慧豆：
          </div>
          <div style={{ marginTop: 30, fontWeight: 500 }}>说明信息：</div>
          <div style={{ fontWeight: 500 }}>{auditDetail.current.desc}</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 120,
            }}
          >
            <Button
              onClick={() => onAuditBtnClicked(false, [auditDetail.current.id])}
            >
              不通过
            </Button>
            <Button
              onClick={() => onAuditBtnClicked(true, [auditDetail.current.id])}
              type="primary"
              style={{ marginLeft: 20 }}
            >
              通过
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
